import PropTypes from 'prop-types';
import React from 'react';

import withTheme from 'core/hocs/withTheme';
import Link from 'core/components/Link';
import { resolveScopedStyles } from 'core/utils/styled-jsx';
import themePropTypes from 'core/utils/prop-types/theme';
import modelPropTypes, { personAttributes } from 'core/utils/prop-types/model';

function Authors(props, context) {
  const {
    authors,
    theme: {
      animations: {
        hover: hoverAnimation,
      },
      controls: {
        topicFooter: {
          links: linksAtoms,
        },
      },
    },
  } = props;

  if (authors.length === 0) return null;

  const { mediaUrlPrefix } = context;

  const scoped = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .link
          font ${linksAtoms.font}
          margin-left ${linksAtoms.marginLeft}
          border-bottom ${linksAtoms.borderBottom}
          transition border-color ${hoverAnimation}
          color ${linksAtoms.color}
          &:hover
            border-bottom ${linksAtoms.hover.borderBottom}
        .linkTitle
          font ${linksAtoms.title.font}
          color ${linksAtoms.title.color}
        .comma
          color ${linksAtoms.color}
      `}</style>
    </scope>
  );

  return (
    <React.Fragment>
      <span className={scoped.wrapClassNames('linkTitle')}>
        {authors.length === 1 ? 'Автор:' : 'Авторы:'}
      </span>
      {authors.map((author, i) => {
        const {
          id: authorId,
          attributes: {
            slug,
            name,
          },
        } = author;

        return (
          <React.Fragment key={authorId}>
            <Link
              to={`${mediaUrlPrefix || ''}/authors/` + slug}
              className={scoped.wrapClassNames('link')}
              type={linksAtoms.type}
              dataQa='authors-link'
            >
              {name}
            </Link>
            {(linksAtoms.showComma && (i + 1) < authors.length) ? <span className={scoped.wrapClassNames('comma')}>,</span> : ''}
          </React.Fragment>
        );
      })}
      <scoped.styles />
    </React.Fragment>
  );
}

Authors.propTypes = {
  theme: themePropTypes(`{
    animations: {
      hover,
    },
    controls: {
      topicFooter: {
        links: {
          borderBottom,
          type,
          marginLeft,
          hover: {
            borderBottom,
          }
        },
      }
    }
  }`),
  authors: PropTypes.arrayOf(modelPropTypes(personAttributes)),
};

Authors.contextTypes = {
  mediaUrlPrefix: PropTypes.string,
};

Authors.defaultProps = {
  authors: [],
};

export default withTheme(Authors);
